import { useEffect } from "react";
import { formatPageTitle } from "../constants/site";

export function usePageTitle(page, { admin = false } = {}) {
  useEffect(() => {
    document.title = formatPageTitle(page, { admin });
  }, [page, admin]);
}
